import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/admin/api";

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
    const [admin, setAdmin] = useState(undefined); // undefined = chargement, null = non connecté

    useEffect(() => {
        api.me()
            .then(setAdmin)
            .catch(() => setAdmin(null));
    }, []);

    const login = async (email, password) => {
        const user = await api.login(email, password);
        setAdmin(user);
        return user;
    };

    const logout = async () => {
        try {
            await api.logout();
        } finally {
            setAdmin(null);
        }
    };

    return (
        <AdminContext.Provider value={{ admin, login, logout }}>
            {children}
        </AdminContext.Provider>
    );
};

export const useAdmin = () => useContext(AdminContext);
